import { createSlice } from "@reduxjs/toolkit";

const getStoredUser = () => {
  try {
    const user = localStorage.getItem("user");
    const token = localStorage.getItem("token");
    if (user && token) {
      return { user: JSON.parse(user), token };
    }
  } catch {
    // ignore parse errors
  }
  return { user: null, token: null };
};

const getStoredProject = () => {
  try {
    const projectName = localStorage.getItem("projectName");
    const projectId = localStorage.getItem("projectId");
    if (projectName && projectId) {
      return { projectName, projectId };
    }
  } catch {
    // ignore parse errors
  }
  return { projectName: null, projectId: null };
};

const getStoredProjects = () => {
  try {
    const projects = localStorage.getItem("projects");
    if (projects) {
      return JSON.parse(projects);
    }
  } catch {
    // ignore parse errors
  }
  return {};
};

const authSlice = createSlice({
  name: "auth",
  initialState: () => {
    const { user, token } = getStoredUser();
    return {
      user,
      token,
      isAuthenticated: !!token,
      ...getStoredProject(),
      projects: getStoredProjects(),
    };
  },
  reducers: {
    setCredentials: (state, action) => {
      const { user, token } = action.payload;
      state.user = user;
      state.token = token;
      state.isAuthenticated = true;
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", token);
    },
    setProject: (state, action) => {
      const { projectName, projectId } = action.payload;
      state.projectName = projectName;
      state.projectId = projectId;
      localStorage.setItem("projectName", projectName);
      localStorage.setItem("projectId", projectId);
    },
    setProjects: (state, action) => {
      state.projects = action.payload;
      localStorage.setItem("projects", JSON.stringify(action.payload));
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.projectName = null;
      state.projectId = null;
      state.projects = {};
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("projectName");
      localStorage.removeItem("projectId");
      localStorage.removeItem("projects");
    },
  },
});

export const { setCredentials, setProject, setProjects, logout } =
  authSlice.actions;
export default authSlice.reducer;
